module.exports = __webpack_public_path__ + "static/fipccartoongiraffehamper-9b62c7e04a089451797ac67a5332a105.jpeg";